/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Send_Link_To_EmailInputs */

const en_send_link_to_email = /** @type {(inputs: Send_Link_To_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send link to email`)
};

const nl_send_link_to_email = /** @type {(inputs: Send_Link_To_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stuur link naar e-mail`)
};

/**
* | output |
* | --- |
* | "Send link to email" |
*
* @param {Send_Link_To_EmailInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const send_link_to_email = /** @type {((inputs?: Send_Link_To_EmailInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Send_Link_To_EmailInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_send_link_to_email(inputs)
	return en_send_link_to_email(inputs)
});